import { useProductDayTripPlanFormModelContext } from "../../../../../context";

export const useDayTripPlanIsShowRoomForGuest = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { isShowRoomForGuest } = viewModel;

	const onSetIsShowRoomForGuest = (value: boolean) => {
		onSetViewModel([
			{
				key: "isShowRoomForGuest",
				value: {
					isEdited: true,
					value,
				},
			},
		]);
	};

	return {
		isShowRoomForGuest,
		onSetIsShowRoomForGuest,
	};
};
